/* global Homie */
import axios from 'axios';

let HomeExistenceValidator = {
	mounted: function() {
		let home_id = Homie.home_id;
		axios.get(`/homes/${home_id}.json`).then(response => {
			this.home = response.data;
			Homie.home = this.home;
			this.$bus.emit('got-home', this.home._step);
		}).catch(function(e){
			// Do not remove this validation. This catch is actually catching every js error, causing that when an error
			// occurs, the user is being redirected (the data for the home is still saved, but he has to restart the complete
			// onboarding process as it is the first time)
			if(Homie.home == undefined || Homie.home == null) {
				window.location.href="/homes/new"
			}
		});
	}
};

export default HomeExistenceValidator;